import { PageHeader, Popconfirm, message, Tooltip } from "antd";
import React, { Component } from "react";
import axios from 'axios'
import { ButtonItem, SegmentedItem, TableItem, cuentaMask } from '../../../Components/Items'
import { connect } from "react-redux";
import AgregarFamilia from "./AgregarFamilia/AgregarFamilia";
import { EditOutlined, CheckCircleOutlined, StopOutlined } from "@ant-design/icons";
import EditarFamilia from "./EditarFamilia/EditarFamilia";
import AgregarFamiliaConAsistente from "./AgregarFamiliaConAsistente/AgregarFamiliaConAsistente";


class Familias extends Component {
  state = {
    todasFamilia: [],
    modalAgregarFamilia: false,
    modalEditarFamilia: false,
    modalEditarFamiliaId: null,
    loading: false,
    valor: 1,
  }
  componentDidMount() {
    this.consultarFamilias(this.state.valor);
  }

  consultarFamilias(valor) {
    this.setState({ loading: true })
    axios
      .post(
        "familias/selectTodasFamilias",
        { empresaId: this.props.empresaId, valor: valor },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false })
        if (res.data.status === 404) {
          this.setState({ todasFamilia: [] });
        } else {
          this.setState({
            todasFamilia: res.data.map(value => {
              return { ...value, accion: { _id: value._id, estado: value.estado } }
            }),
          });
        }
      });
  }
  deshabilitarFamilia(value) {
    axios
      .post(
        "familias/deshabilitarFamilia",
        { familiaId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Familia deshabilitada");
        } else {
          message.error("Sucedio un eror y no se pudo deshabilitar");
        }
        this.consultarFamilias(this.state.valor);
      });
  }
  habilitarFamilia(value) {
    axios
      .post(
        "familias/habilitarFamilia",
        { familiaId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Familia habilitada");
        } else {
          message.error("Sucedio un eror y no se pudo habilitar");
        }
        this.consultarFamilias(this.state.valor);
      });
  }
  abrirAgregarFamilia() {
    this.setState({ modalAgregarFamilia: true });
  }
  cerrarAgregarFamilia() {
    this.setState({ modalAgregarFamilia: false });
    this.consultarFamilias();
  }
  abrirAgregarFamiliaConAsistente() {
    this.setState({ modalAgregarFamiliaConAsistente: true });
  }
  cerrarAgregarFamiliaConAsistente() {
    this.setState({ modalAgregarFamiliaConAsistente: false });
    this.consultarFamilias();
  }
  abrirEditarFamilia(id) {
    this.setState({ modalEditarFamilia: true, modalEditarFamiliaId: id });
  }
  cerrarEditarFamilia() {
    this.setState({ modalEditarFamilia: false });
    this.consultarFamilias();
  }
  render() {
    const columns = [
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        sorter: (a, b) => {
          if (a.nombre < b.nombre) {
            return -1;
          }
          if (a.nombre > b.nombre) {
            return 1;
          }
          return 0;
        },
        buscar: "nombre",
      },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        sorter: (a, b) => {
          if (a.descripcion < b.descripcion) {
            return -1;
          }
          if (a.descripcion > b.descripcion) {
            return 1;
          }
          return 0;
        },
        buscar: "descripcion",
      },
      {
        title: "Tipo de Familia",
        dataIndex: "tipoDeFamilia",
        key: "tipoDeFamilia",
        buscar: "tipoDeFamilia",
        sorter: (a, b) => {
          if (a.tipoDeFamilia < b.tipoDeFamilia) {
            return -1;
          }
          if (a.tipoDeFamilia > b.tipoDeFamilia) {
            return 1;
          }
          return 0;
        },
        width: "15%",
      },
      {
        title: "Cuenta Inventario",
        dataIndex: "cuentaInventario",
        key: "cuentaInventario",
        render: (value) => {
          if (value?.nivel1) {
            return cuentaMask(
              value.nivel1 +
              value.nivel2 +
              value.nivel3 +
              value.nivel4 +
              value.nivel5
            )
          } else {
            return '-'
          }
        }
      },
      {
        title: "Cuenta Costo/Gasto",
        dataIndex: "cuentaCostoGasto",
        key: "cuentaCostoGasto",
        render: (value) => {
          if (value?.nivel1) {
            return cuentaMask(
              value.nivel1 +
              value.nivel2 +
              value.nivel3 +
              value.nivel4 +
              value.nivel5
            )
          } else {
            return '-'
          }
        }
      },
      {
        title: "Cuenta Ajuste Inventario",
        dataIndex: "cuentaAjusteInventario",
        key: "cuentaAjusteInventario",
        render: (value) => {
          if (value?.nivel1) {
            return cuentaMask(
              value.nivel1 +
              value.nivel2 +
              value.nivel3 +
              value.nivel4 +
              value.nivel5
            )
          } else {
            return '-'
          }
        }
      },
      {
        title: "Cuenta Ingreso Contado",
        dataIndex: "cuentaIngresoContado",
        key: "cuentaIngresoContado",
        render: (value) => {
          if (value?.nivel1) {
            return cuentaMask(
              value.nivel1 +
              value.nivel2 +
              value.nivel3 +
              value.nivel4 +
              value.nivel5
            )
          } else {
            return '-'
          }
        }
      },
      {
        title: "Cuenta Ingreso Credito",
        dataIndex: "cuentaIngresoCredito",
        key: "cuentaIngresoCredito",
        render: (value) => {
          if (value?.nivel1) {
            return cuentaMask(
              value.nivel1 +
              value.nivel2 +
              value.nivel3 +
              value.nivel4 +
              value.nivel5
            )
          } else {
            return '-'
          }
        }
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (value, index) => {
          let buttons = [];

          // Botón Editar
          if (this.props.permisoEditarFamilia) {
            buttons.push(
              <Tooltip title="Editar Familia" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`editar-${index}`}
                  type="default"
                  size="small"
                  cyan
                  icon={<EditOutlined />}
                  onClick={() => this.abrirEditarFamilia(value._id)}
                >
                </ButtonItem>
              </Tooltip>
            );
          }

          // Botón Habilitar/Deshabilitar
          if (this.props.permisoDeshabilitarFamilia) {
            if (value.estado === 1) {
              buttons.push(
                <Popconfirm
                  key={`deshabilitar-${index}`}
                  title="Seguro que quieres deshabilitar esta familia"
                  onConfirm={() => this.deshabilitarFamilia(value._id)}
                  okText="Si"
                  cancelText="No"
                >
                  <Tooltip title="Deshabilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                    <ButtonItem
                      type="default"
                      size="small"
                      lima
                      icon={<CheckCircleOutlined />}
                    >
                    </ButtonItem>
                  </Tooltip>
                </Popconfirm>
              );
            } else {
              buttons.push(
                <Popconfirm
                  key={`habilitar-${index}`}
                  title="Seguro que quieres habilitar esta familia"
                  onConfirm={() => this.habilitarFamilia(value._id)}
                  okText="Si"
                  cancelText="No"
                >
                  <Tooltip title="Habilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                    <ButtonItem
                      type="default"
                      size="small"
                      rojo
                      icon={<StopOutlined />}
                    >
                    </ButtonItem>
                  </Tooltip>
                </Popconfirm>
              );
            }
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ]
    return (
      <>
        <PageHeader
          title="Familias"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <>
              {window.innerWidth > 1000 &&
                <SegmentedItem
                  options={[{ label: 'Activo', value: 1 }, { label: 'Deshabilitado', value: 2 }, { label: 'Todos', value: 3 }]}
                  onChange={(value) => {
                    this.consultarFamilias(value)
                    this.setState({ valor: value })
                  }}
                  value={this.state.valor}
                />
              }
              {this.props.permisoAgregarFamilia &&
                <ButtonItem
                  type="primary"
                  key="agregarFamiliaConAsistente"
                  onClick={this.abrirAgregarFamiliaConAsistente.bind(this)}
                   className="botonAgregar"
                >
                  Nueva Familia Asistida
                </ButtonItem>}
              {this.props.permisoAgregarFamilia &&
                <ButtonItem
                  type="primary"
                  key="agregarFamilia"
                  olivo
                  onClick={this.abrirAgregarFamilia.bind(this)}
                   className="botonAgregar"
                >
                  Agregar Familia
                </ButtonItem>}
            </>
          }
        />
        <TableItem
          loading={this.state.loading}
          size='small'
          dataSource={this.state.todasFamilia}
          columns={columns}
          onRow={(record) => ({
            onDoubleClick: () => this.abrirEditarFamilia(record._id),
          })}
        />
        <AgregarFamilia
          visible={this.state.modalAgregarFamilia}
          cerrarAgregarFamilia={this.cerrarAgregarFamilia.bind(this)}
        />
        <AgregarFamiliaConAsistente
          visible={this.state.modalAgregarFamiliaConAsistente}
          cerrarAgregarFamiliaConAsistente={this.cerrarAgregarFamiliaConAsistente.bind(this)}
          familiasLength={this.state.todasFamilia.length}
        />
        <EditarFamilia
          visible={this.state.modalEditarFamilia}
          id={this.state.modalEditarFamiliaId}
          cerrarEditarFamilia={this.cerrarEditarFamilia.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoAgregarFamilia: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615ccf0bf30e81b54183cf79")?.activado,
    permisoEditarFamilia: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615ccf3df30e81b54183cf7a")?.activado,
    permisoDeshabilitarFamilia: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615ccfc7f30e81b54183cf7b")?.activado,
  };
};

export default connect(mapStateToProps)(Familias);